'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable max-len */
var FollowButton = function (_PureComponent) {
  _inherits(FollowButton, _PureComponent);

  function FollowButton() {
    _classCallCheck(this, FollowButton);

    return _possibleConstructorReturn(this, (FollowButton.__proto__ || Object.getPrototypeOf(FollowButton)).apply(this, arguments));
  }

  _createClass(FollowButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('friendship', 'uni-btn--xsmall', {
            'uni-btn--confirm': this.props.isFollowing,
            'uni-btn--subtle': !this.props.isFollowing
          }), href: '#', onClick: this.props.onClickFollow },
        this.props.isFollowing ? _react2.default.createElement(
          'svg',
          { className: 'uni-btn__icon', viewBox: '0 0 32 32', 'aria-labelledby': 'confirmationTitle', role: 'img', 'fill-rule': 'evenodd' },
          _react2.default.createElement(
            'title',
            { id: 'confirmationTitle' },
            'confirmation'
          ),
          _react2.default.createElement('path', { fill: 'inherit', d: 'M3 16C3 8.831 8.832 3 16 3c7.169 0 13 5.831 13 13s-5.831 13-13 13C8.832 29 3 23.169 3 16zm17.889-5.31l-7.161 8.535-2.85-2.39a.931.931 0 0 0-1.305.116l-.597.713a.923.923 0 0 0 .113 1.306l4.272 3.585a.926.926 0 0 0 .675.21l.002.002a.93.93 0 0 0 .63-.33l8.355-9.957a.925.925 0 0 0-.113-1.308l-.713-.599a.927.927 0 0 0-1.308.117z' })
        ) : '',
        this.props.isFollowing ? 'Following' : 'Follow'
      );
    }
  }]);

  return FollowButton;
}(_react.PureComponent);
/* eslint-enable max-len */

FollowButton.propTypes = {
  feedUserId: _react.PropTypes.shape({
    type: _react.PropTypes.number.isRequired,
    relatedId: _react.PropTypes.string.isRequired
  }).isRequired,
  isFollowing: _react.PropTypes.bool.isRequired,
  onClickFollow: _react.PropTypes.func.isRequired
};
exports.default = FollowButton;